import React from 'react'

import {
    Inject,
    ChartComponent,
    SeriesCollectionDirective,
    SeriesDirective,
    ColumnSeries,
    Tooltip,
    Category,
    DataLabel,
    Legend,
  } from '@syncfusion/ej2-react-charts';

import "../Tables/Customs/syncfusion-grid-overrides.css";
import "@syncfusion/ej2-base/styles/bootstrap5.css";
import "@syncfusion/ej2-buttons/styles/bootstrap5.css";
import "@syncfusion/ej2-inputs/styles/bootstrap5.css";
import "@syncfusion/ej2-navigations/styles/bootstrap5.css";
import "@syncfusion/ej2-popups/styles/bootstrap5.css";
import "@syncfusion/ej2-splitbuttons/styles/bootstrap5.css";
import "@syncfusion/ej2-dropdowns/styles/bootstrap5.css";
import "@syncfusion/ej2-grids/styles/bootstrap5.css";
import "../../../styles/chartResponsive.css";

import { useTheme } from '../../../contexts/ThemeContext';
export const ChartColumnsNormal = (props) => {
  const { isDark } = useTheme();

    return (
        <div className="chart-container chart-columns-container">
            <ChartComponent
                id={props.id}
                height={'100%'}
                width={'100%'}
                chartArea={{ border: { width: 0 } }}
                margin={{ left: 0, right: 0, top: 0, bottom: 40 }}
                primaryXAxis={{ valueType: "Category", title: "", titleStyle: {color: isDark ? "#FFF" : "#000"} }}
                tooltip={{ enable: true }}
                legendSettings={{ 
                    visible: true, 
                    position: "Bottom",
                    alignment: "Center",
                    textStyle: { color: isDark ? "#ffffff" : "#000000" }
                }}
                style={{ width: '100%', height: '100%', minHeight: '300px' }}
            >
                <Inject services={[ColumnSeries, Category, Tooltip, DataLabel, Legend]} />
                <SeriesCollectionDirective>
                    <SeriesDirective
                        type="Column"
                        dataSource={props.data}
                        xName={props.xName}
                        yName={props.yName}
                        name={props.name}
                        marker={{
                            dataLabel: {
                                visible: true,
                                position: "Top",
                                font: {
                                    color: isDark ? "#ffffff" : "#000000",
                                    size: "12px"
                                }
                            }
                        }}
                    />
                </SeriesCollectionDirective>
            </ChartComponent>
        </div>
    )
}
